import { DemandReferenceResolution } from '../../../Interfaces/api/catalog/demand-reference.interface';
import { MY_APPROVALS_ROUTE_PATH, MY_DEMANDS_ROUTE_PATH } from '../Consts/demand-reference-route.const';

export function buildDemandReferenceDestination(resolution: DemandReferenceResolution): string[] {
  const area =
    resolution.relationship === 'requester' ? MY_DEMANDS_ROUTE_PATH : MY_APPROVALS_ROUTE_PATH;

  return [area, resolution.subject_type, resolution.demand_id];
}
